import React, { useEffect } from 'react';
import { useAuth } from 'oidc-react';
import {
  DASHBOARD_API_TOKEN_NAME,
  LOGOUT_URL_DEV,
  LOGOUT_URL_END_PATH,
  LOGOUT_URL_PROD,
  LOGOUT_URL_QA,
} from '../../constants';
import { env } from '../../env';
import { useAppSelector } from '../../common/hooks';
import { LocationType } from '../../models/enums';
import { RootState } from '../../redux/store';

const SignOutPage = () => {
  const isMock = window.name === 'true';

  const auth = isMock ? null : useAuth();

  function getApiUrlByHostname() {
    const hostname = window.location.hostname;

    if (hostname.includes('dev') || hostname.includes('localhost')) {
      return LOGOUT_URL_DEV;
    }

    if (hostname.includes('qa')) {
      return LOGOUT_URL_QA;
    }

    if (hostname.includes('shrm.org')) {
      return LOGOUT_URL_PROD;
    }

    // Default fallback
    return LOGOUT_URL_PROD;
  }

  function redirectionAfterLogout() {
    setTimeout(() => {
      window.location.replace(getApiUrlByHostname() + LOGOUT_URL_END_PATH);
    }, 2000);
  }

  function clearAllCookies() {
    const cookies = ['login-token', 'JSESSIONID', 'JWTSSOIDENTITY', 'SSOIDENTITY'];
    cookies.forEach(cookie => {
      const paths = ['/'];
      paths.forEach(path => {
        document.cookie = `${cookie.trim()}=; domain=.dev-aem-www.shrm.org; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path};`;
        document.cookie = `${cookie.trim()}=; domain=.shrm.org; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path};`;
      });
    });
  }

  const handleLogout = async () => {
    clearAllCookies();
    if (auth.userData.profile.email) {
      try {
        // window.open(getApiUrlByHostname() + LOGOUT_URL_END_PATH, '_blank');
        await auth.userManager.removeUser();
        await auth.signOut();
      } catch (error) {
        console.error('Logout Failed', error);
      }
    }
  };

  function logout() {
    sessionStorage.removeItem(DASHBOARD_API_TOKEN_NAME);
    localStorage.clear();
    sessionStorage.clear();
    handleLogout();
    redirectionAfterLogout();
  }

  useEffect(() => {
    logout();
  }, []);

  return <></>;
};

export default SignOutPage;
